import React from 'react';
import Icon from '../../../components/AppIcon';


const SuccessConfirmation = ({ plannerData, onDownload }) => {
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i))?.toFixed(2)) + ' ' + sizes?.[i];
  };

  const formatTimestamp = (timestamp) => {
    return new Date(timestamp)?.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 md:p-8 text-center">
      {/* Success Icon */}
      <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-6">
        <Icon name="CheckCircle" size={32} className="text-success" />
      </div>
      {/* Success Message */}
      <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-3">
        Your Planner is Ready!
      </h1>
      <p className="font-body text-muted-foreground mb-8 max-w-md mx-auto">
        Your personalized day planner has been successfully generated and is ready for download.
      </p>
      {/* Download Button */}
      <div className="space-y-4">
        <button
          onClick={onDownload}
          className="w-full bg-primary text-primary-foreground px-6 py-4 rounded-lg font-heading font-semibold text-lg hover:bg-primary/90 transition-colors duration-200 flex items-center justify-center space-x-3 group"
        >
          <Icon name="Download" size={20} className="group-hover:animate-bounce-gentle" />
          <span>Download Your Planner</span>
        </button>
        
        <p className="font-caption text-xs text-muted-foreground">
          PDF format • Compatible with all devices • Print-ready quality
        </p>
      </div>
    </div>
  );
};

export default SuccessConfirmation;